var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        centerScreen: "",
        persistent: "",
        withoutCloseButton: "",
        maxWidth: "400px"
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function() {
            return [
              _c("span", { staticClass: "text-heading-small ml-4 mt-2" }, [
                _vm._v("Nova versão disponível")
              ])
            ]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function() {
            return [
              !_vm.loopDetected && !_vm.autoReloadActive
                ? _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: _vm.dismiss } },
                    [_vm._v(" Lembrar mais tarde ")]
                  )
                : _vm._e(),
              !_vm.loopDetected
                ? _c(
                    "BaseButton",
                    { attrs: { primary: "" }, on: { click: _vm.reload } },
                    [_vm._v(" Atualizar agora ")]
                  )
                : _vm._e()
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "pa-4" }, [
        _vm.loopDetected
          ? _c("p", { staticClass: "ma-0" }, [
              _vm._v(" Não conseguimos atualizar automaticamente. Pressione "),
              _c("strong", [_vm._v("Ctrl+Shift+R")]),
              _vm._v(" (ou "),
              _c("strong", [_vm._v("Cmd+Shift+R")]),
              _vm._v(" no Mac) para recarregar limpando o cache do navegador. ")
            ])
          : _vm.autoReloadActive
          ? _c("p", { staticClass: "ma-0" }, [
              _vm._v(
                " Uma nova versão da AAWZ está disponível. A página será atualizada automaticamente em alguns segundos. "
              )
            ])
          : _c("p", { staticClass: "ma-0" }, [
              _vm._v(
                " Uma nova versão da AAWZ está disponível. Atualize quando quiser para carregar a versão nova. "
              )
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }